<style lang="scss" scoped>
.main-wrapper {
	min-width: 1200px;
    padding: 50px 10px 50px 64px;
    box-sizing: border-box;
    min-height: 100vh;
    transition: all 0.3s ease-in-out;
    background-color: #f5f5f5;
    &-screen {
        padding-left: 10px !important;
    }
    &-fullscreen {
        padding-left: 10px;
        padding-top: 10px;
    }
    &-port {
        padding-left: 230px;
    }
}
.main-loading {
    background-color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
}

.slide-bar {
    position: fixed;
    top: 53px;
    left: 41px;
    // z-index: 20;
    z-index: 101;
    color: #fff;
    line-height: 36px;
    text-align: center;
    overflow: hidden;
    width: 18px;
    height: 38px;
    border: 1px solid #4d4d4d;
    background-color: #4d4d4d;
    border-radius: 2px 0 0 2px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}
.slide-bar-port {
    left: 198px;
}
.slide-bar-hide {
    left: 0px;
}
.layout-bg {
    position: absolute;
    background: url(../../image/bg.jpg) no-repeat 50% / cover;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
}
</style>

<template>
	<main :class="mainClasses" v-if="ready">
		<aside :class="slideClasses" @click="clickAside" v-show="getShowAside">
			<vIcon type="ios-arrow-forward" v-show="!open"></vIcon>
			<vIcon type="ios-arrow-back" v-show="open"></vIcon>
		</aside>
		<comp-nav v-show="!getFullScreen" />
<!--		<compTabNav v-show="showtabNav"></compTabNav>-->
		<transition name="move-left">
			<keep-alive>
				<comp-menu v-show="open && !getFullScreen" />
			</keep-alive>
		</transition>
		<!-- <template> -->
        <!-- 头部标题展示 -->
		<comp-breadlist v-show="hasMetaBread && !getFullScreen && showBreadlist"></comp-breadlist>
		<transition>
			<!-- <keep-alive v-if="isKeepAlive" :max="3">
				<router-view />
			</keep-alive>-->
			<router-view :key="getSysId" />
		</transition>
		<!-- </template> -->
	</main>
	<div v-else class="layout-bg">
		<compDelayloading
			class="main-loading"
			loading
			fix
			:delay="delayloading"
			:tip="initText"
			:transfer="false"
			:time="0"
			@on-cancel="initUserInfo(true)"
			@on-back="goback"
		></compDelayloading>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Cookies from 'js-cookie'
import compNav from "./nav/index";
//import compTabNav from "./tabnav/index";
import compMenu from "./menu/index";
import compBreadlist from "../templates/breadlist";
import compDelayloading from "../templates/delayloading";
import { LogoutBase } from "../../service/base";
export default {
	name: "App",
	components: {
		compNav,
		compMenu,
		compBreadlist,
		compDelayloading,
		//compTabNav,
	},
	data() {
		return {
            closeaside:true,
			open: true,
			ready: false,
			initText: "",
            delayloading: false,
            showtabNav: Cookies.get("showtab")? eval(Cookies.get("showtab").toLowerCase()) : false,
            showBreadlist: Cookies.get("showtab") ? !eval(Cookies.get("showtab").toLowerCase()) : true,
			goback: () => { } //立即跳转
		};
	},
	created() {
		/**初始化关闭菜单 */
		this.open = this.$route.name !== 'homePanel';
		this.initText = this.$t("global.common.init");
        this.isPort = location.host.indexOf('port.') >= 0 ? true : false;

		this.$VMessage.config({ duration: 6 });
		this.$VModal.config({ store: this.$store, i18n: this.$i18n }, true);
		this.initLang(null,true);
        this.initUserInfo();
        // console.log(eval(Cookies.get("showtab").toLowerCase()),'Cookies.get("showtab")')
	},
	mounted() {
        this.handleUserBrowser();
        this.bus.$on("changeshowtab", value => {
            // console.log(value,eval(value.toLowerCase()),'djdjdjdjfghgnhg')
            // this.showBreadlist = !eval(value.toLowerCase());
            // this.showtabNav = eval(value.toLowerCase());

            this.$set(this.$data,'showtabNav',!eval(value.toLowerCase()));
            this.$set(this.$data,'showBreadlist',eval(value.toLowerCase()));

        });
	},
    // watch:{
    //     $route: function (to, from) {
    //         console.log(this.$route,'this.$route.meta.symbal')
    //         // 针对风控几个页面不要侧边栏
    //         if(this.$route.meta.symbal == 'closeslide'){
    //             this.closeaside = false;
    //             this.open = false;
    //         }else{
    //             this.closeaside = true;
    //             this.open = true;
    //         }
    //     }
    // },
	computed: {
		...mapGetters(["getSysId", "getFullScreen"]),
		...mapGetters("layout", ["getMenuList", "getMatchRoute"]),
		hasMetaBread() {
			return this.$route.meta.bread !== false;
        },
        getShowAside(){
            let boll = true;
            if(this.$route.meta.symbal == 'closeslide'){
                this.closeaside = false;
                this.open = false;
                boll = false
            }else{
                this.closeaside = true;
                this.open = true;
                boll = true
            }
            return boll;
        },

		isKeepAlive() {
			return this.$route.meta.keepAlive;
		},
		slideClasses() {
			return [
				"slide-bar",
                {
                    "slide-bar-port": this.isPort
                },
				{
					"slide-bar-hide": !this.open
				}
			];
		},
		mainClasses() {
			return [
				"main-wrapper",
				{
					"main-wrapper-screen": !this.open,
					"main-wrapper-fullscreen": this.getFullScreen,
                    "main-wrapper-port": this.isPort
				}
			];
		}
	},
	methods: {
		...mapMutations("layout", ["setRouteId"]),
        clickAside(){
            this.open = !this.open;
            this.bus.$emit("changeaside", 1);
        },
        /**
         * 获取用户信息
         */
		async initUserInfo(isJump) {
			this.initText = this.$t("global.common.init");
			this.ready = this.delayloading = false;
			await this.$store.dispatch("actionGetUserInfo", isJump).catch(err => {
				//port 项目
				const isPortLogin = location.host.indexOf(this.handleHostname('port.onepinnovate.com')) > -1
				this.delayloading = true;
				if (err.passwordExpired) {//密码过期
					if (isPortLogin) {
						if (this.$route.name == 'password') {
							// this.ready = true;
							// this.delayloading = false;
							this.initUserInfo(true);//再次获信息更新
						} else {
							this.goback = () => {
								//防止本页面循环
								this.$router.push({ name: "password" });
								// this.ready = true;
								// this.delayloading = false;
								this.initUserInfo(true);//再次获信息更新
							};
						}
					} else {
						this.goback = () => {
							location.href = this.handleHostname(`https://${global.envPrefix}port.onepinnovate.com/home/password`);
						};
					}
					this.initText = `<div class=color-error>${this.$t(
						"global.common.reset_password"
					)}</div>`;
				} else {
					this.goback = isPortLogin ? () => {
						Cookies.remove('token', { domain: global.DOMAIN });
						this.$router.push({ name: "login" });
					} : LogoutBase;
                    console.error('错误e4', err);
					this.initText = `<div class=color-error>${this.$t(
						// "global.common.initError"
                        "global.common.newInitError"
					// )}<pre>${err.message}</pre></div>`;
                    )}<pre></pre></div>`;
				}
                // return
				return Promise.reject();
			});
			await this.initRouteId(this.$route.path).catch(err => {
				//捕获错误 防止意外退出
				console.log(err,'e3')
			});
			setTimeout(() => {//菜单初始化问题，菜单重复渲染
				this.ready = true;
			}, 10)
		},
        /**
         * 初始化多语言
         */
		async initLang(lang, isForce) {
			// this.$store.dispatch("actionGetLangList").then(cb => { cb(this.$i18n); });
            this.$store.dispatch('actionGetLangList', { lang, isForce }).then(cb => cb(this.$i18n));
		},
        /**
         * 初始化定位菜单,兼容路由
         */
		async initRouteId(path) {
			const menuList = Object.values(this.getMenuList);
			let routeData = this.getMatchRoute(path, menuList);
			if (!routeData && /\/update\/(edit|add|query)$/i.test(path)) {
				routeData = this.getMatchRoute(path.replace(/\/update\/(edit|add|query)$/i, '\/list'), menuList);
			}
			if (routeData) this.setRouteId(routeData.id);
		},
	}
};
</script>
